import { Dialog, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import FormKeyword from "../form/FormKeyword";
import { IFormEvent } from "../form/Form.interface";
import Util, { fetchImgs } from "../services/util";
import axios from "axios";
import DataCommon from "../ui/DataCommon";
import FormSelect from "../form/FormSelect";
import { Status } from "../common/config";

export default function SelectNews(props: { onClose: (news?: any) => void }) {
  const [query, setQuery] = React.useState({ limit: 20, skip: 0, keyword: '', channel: '', tags: '', status: 3 })
  const [data, setData] = React.useState<{ count: number, data: any[] }>()
  const [channelOption, setChannelOption] = React.useState<any>([])
  const [tagOption, setTagOption] = React.useState<any>([])

  function handleQueryChange(e: IFormEvent) {
    setQuery(Util.formChange(e, query))
  }

  function find() {
    axios.post('cms/newslist', query).then(({ data }) => {
      data.data.forEach((i: any) => {
        i.newimg = Array.from(new Set([i.newimg, ...fetchImgs(i.text)].filter(i => !!i)))
      })
      setData(data)
    })
  }

  React.useEffect(() => {
    axios.post('cms/channelsIndex', {}).then(({ data }) => {
      setChannelOption(data)
    })
    axios.post('cms/tagsIndex', {}).then(({ data }) => {
      setTagOption(data)
    })
  }, [])


  React.useEffect(find, [query])

  return <Dialog open onClose={() => props.onClose()}>
    <Stack sx={{ ml: 1 }}>
      <Stack direction="row" sx={{ mt: 2 }} spacing={2}>
        <FormKeyword name={"keyword"} value={query.keyword} label={"搜"} onChange={handleQueryChange} />
        <FormSelect label="频道" name="channel" value={query.channel} onChange={handleQueryChange}
          options={[{ title: '全部', value: '' }, ...channelOption]} />
        <FormSelect label="标签" name="tags" value={query.tags} onChange={handleQueryChange}
          options={[{ title: '全部', value: '' }, ...tagOption]} />
      </Stack>

      <Stack>
        {(!!data?.data.length) && <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>频道</TableCell>
              <TableCell>标题</TableCell>
              <TableCell>题图</TableCell>
              <TableCell>发布日期</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.data.map((i, idnex) => <TableRow hover key={idnex} sx={{ td: { p: .5 } }} onClick={() => {
              props.onClose(i)
            }}>
              <TableCell>{i._id}</TableCell>
              <TableCell>
                <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>{i.channel}</Typography>
                <br />
                <Typography variant="caption">{i.tags.join(', ')}</Typography>
              </TableCell>
              <TableCell>
                <Typography>{i.title}</Typography></TableCell>
              <TableCell>
                {i.newimg[0] && <img alt="" width={60} height={40} src={i.newimg[0]} />}
              </TableCell>
              <TableCell>{i.pubDate}</TableCell>
              <TableCell>{Status.newsAudit[i._audit.status]}</TableCell>
            </TableRow>)}
          </TableBody>
        </Table>}
        <DataCommon data={data} query={query} setQuery={setQuery} />
      </Stack>
    </Stack>
  </Dialog>
}